export default __webpack_public_path__ + "static/media/photoshop.3b735f4e.png";